import type { Reducer } from "redux"

import { SettingsState, SettingsActionTypes, SettingsAction } from "./types"

const initialState: SettingsState = {
    loading: false,
    maintenanceMessage: {
        operationsBody: "",
        operationsIsActive: false,
        operationsTitle: "",
        userHidden: false,
    },
    infoBanner: null,
    infoBannerLoading: false,
}

const settingsReducer: Reducer<SettingsState, SettingsAction> = (state = initialState, action) => {
    switch (action.type) {
        case SettingsActionTypes.DriftmeldingLoading:
            return {
                ...state,
                loading: true,
            }

        case SettingsActionTypes.DriftmeldingLoaded:
            return {
                ...state,
                loading: false,
            }

        case SettingsActionTypes.DriftmeldingSuccess: {
            const isAndroid = navigator?.userAgent.toLowerCase().indexOf("android") > -1
            const maintenanceMessage = isAndroid
                ? action.payload.appMaintenanceMessageAndroid
                : action.payload.appMaintenanceMessageIOS

            return {
                ...state,
                maintenanceMessage: {
                    ...maintenanceMessage,
                    userHidden: false,
                },
            }
        }

        case SettingsActionTypes.HideMaintenanceMessage: {
            return {
                ...state,
                maintenanceMessage: {
                    ...state.maintenanceMessage,
                    userHidden: true,
                },
            }
        }

        case SettingsActionTypes.InfoBannerLoading:
            return { ...state, infoBannerLoading: true }

        case SettingsActionTypes.InfoBannerLoaded:
            return { ...state, infoBannerLoading: false }

        case SettingsActionTypes.InfoBannerSuccess:
            return { ...state, infoBanner: action.payload }

        default:
            return state
    }
}

export default settingsReducer
